<template>
  <div>
    <base-header
      class="pb-9 pt-4"
      :type="$route.meta.headerClass ? $route.meta.headerClass : 'success'"
    >
    </base-header>
    <div class="container-fluid mt--9">
      <div class="row">
        <div class="col">
          <div class="card shadow">
            <div class="card-header">
              <span class="h3">Brightcove stream channels</span>
            </div>
            <div class="card-body">
              <div v-if="channelsLoading" class="py-4 text-center">
                <loading-spinner></loading-spinner>
              </div>
              <ul v-else class="list-group list-group-flush list my--3">
                <li
                  v-for="(channel, index) in channels"
                  class="list-group-item px-0"
                  :key="channel.id"
                >
                  <channel :channel="channel" :key="channel.id"></channel>
                </li>
              </ul>
              <div v-if="!channelsLoading && channels.length === 0" class="text-muted">
                No channels set up yet.
              </div>
            </div>
            <!-- <el-table
              class="table-responsive align-items-center table-flush"
              header-row-class-name="thead-light"
              lazy
              :data="channels"
            >
              <el-table-column min-width="110px">
                <div slot-scope="{ row }" class="table-actions">
                   <a
                    class="mb-0"
                    :href="`/#/livestreams/stream/${row.id}`"
                  >


                  </a>
                </div>
              </el-table-column>
            </el-table> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RTMP from "./Components/RTMP";
import Channel from "./Components/Channel";
export default {
  components: { rtmp: RTMP, channel: Channel },
  name: "streams",
  data() {
    return {
      /** true until getCurrent finishes; avoids flashing "No channels" before fetch */
      channelsLoading: true,
    };
  },
  computed: {
    config() {
      return this.$store.getters["config/config"];
    },
    users() {
      return this.$store.getters["users/users"];
    },
    user() {
      return this.$store.getters["user/user"];
    },
    current() {
      return this.$store.getters["livestreams/current"];
    },
    /** Brightcove Live jobs only (exclude AWS match sessions). */
    channels() {
      const raw = this.current;
      if (!Array.isArray(raw)) return [];
      const list = raw
        .filter((job) => job && job.provider !== "aws")
        .map((job) => ({
          id: job.id,
          provider: job.provider || null,
          name: job.name || (job.videocloud && job.videocloud.video && job.videocloud.video.name) || "Unnamed channel",
        }));
      return list.sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
      );
    },
    rtmpOutputs() {
      return this.$store.getters["rtmpOutputs/array"];
    },
    watermarks() {
      return this.$store.getters["files/byWhat"]("livestream-county-logo");
    },
    // players() {
    //   return this.$store.getters["brightcovePlayers/array"];
    // },
    // player() {
    //   return this.$store.getters["brightcovePlayers/byId"](this.temp.player);
    // },
    loading() {
      return this.$store.getters["user/loading"];
    },
    newFeed() {
      return this.$store.getters["rtmpOutputs/byId"](this.temp.newFeed);
    },
  },
  mounted() {
    this.$store.dispatch("livestreams/getCurrent").finally(() => {
      this.channelsLoading = false;
    });
    this.$store.dispatch("rtmpOutputs/fetchAndAdd");
    this.$store.dispatch("files/fetchAndAdd", {
      where: [["what", "==", "livestream-county-logo"]],
    });
  },
  methods: {
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
  },
};
</script>

<style>
</style>
